import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import * as Sentry from "@sentry/react";

// בפיתוח: לא רושמים SW — כדי שריענון תמיד יטען קוד מעודכן מ-Vite (ה-SW של dev שמר במטמון וגרם לעיצוב ישן להופיע לסירוגין)
// אם צריך אופליין ב-dev: פתח את האפליקציה, הפעל רישום ידני של sw-offline-dev.js פעם אחת, ואז נתק רשת.
if (import.meta.env.DEV && typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations?.().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
}

// בפרודקשן: רישום PWA + ריענון אוטומטי כשמתגלה גרסה חדשה — מנהלי סניפים תמיד יראו קוד מעודכן
if (!import.meta.env.DEV && typeof window !== 'undefined') {
  import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({ immediate: true });
  });
}

// אתחול Sentry עם ה-DSN האישי שלך מהתמונה
Sentry.init({
  dsn: "https://1476123988d68e8f5ba1ab1dd5d30658@o4510872356913152.ingest.us.sentry.io/4510872363008000",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});


ReactDOM.createRoot(document.getElementById('root')).render(
    <App />
)